module.exports = __webpack_public_path__ + "img/sim.671b9865.svg";